"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentProvider = void 0;
const domain_1 = require("../../../domain");
const rxjs_1 = require("rxjs");
class AssignmentProvider {
    constructor(contentProvider, settingsProvider) {
        this.contentProvider = contentProvider;
        this.settingsProvider = settingsProvider;
    }
    async assignment(id) {
        const [content, settings] = await Promise.all([
            this.contentProvider.content(id),
            this.settingsProvider.settings(id),
        ]);
        return content && settings && domain_1.Assignment.from(content, settings);
    }
    assignmentStream(id) {
        return (0, rxjs_1.combineLatest)(this.contentProvider.contentStream(id), this.settingsProvider.settingsStream(id), (content, settings) => content && settings && domain_1.Assignment.from(content, settings));
    }
}
exports.AssignmentProvider = AssignmentProvider;
//# sourceMappingURL=AssignmentProvider.js.map